import { AxiosInstance } from 'axios';
import { SignupViaEmailAndPasswordInput, SignupViaUserSpaceInviteInput } from './inputs';
import { UserRef } from './refs';

export default class ClientSignup {
    private basePath = '/api/client-signup';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Signup new user using email and password form data
    signUpViaEmailAndPassword = async (input: SignupViaEmailAndPasswordInput): Promise<UserRef> => {
        const { data } = await this.http.post(`${this.basePath}/email-password`, input);
        return data;
    };

    // Signup using space invite
    signUpViaUserSpaceInviteInput = async (input: SignupViaUserSpaceInviteInput): Promise<UserRef> => {
        const { data } = await this.http.post(`${this.basePath}/user-space`, input);
        return data;
    };
}
